import * as React from 'react';
import { IFollowGroup } from '../follow';
import FollowRow, { IFollowRowActions } from './follow_row';
import FollowsCallout from './follows_callout';
import { get } from 'lodash';
import Tiles from './tiles';

const DEFAULT_CALLOUT_THRESHOLD = 10;

interface Props {
  followGroup?: IFollowGroup;
  calloutThreshold?: number;
  actions?: IFollowRowActions;
  enableDigestToggle?: boolean;
}

export default class FollowsList extends React.Component<Props, null> {
  static defaultProps: Partial<Props> = {
    calloutThreshold: DEFAULT_CALLOUT_THRESHOLD,
  };

  renderCallout() {
    if (!this.props.followGroup) { return null; }

    if (this.props.followGroup.follows.length > this.props.calloutThreshold) {
      return null;
    }

    if (!get(this.props, 'followGroup._links.callout')) {
      return null;
    }

    return (
      <FollowsCallout
        actionText={this.props.followGroup.callout_link_text}
        description={this.props.followGroup.description}
        actionURL={this.props.followGroup._links.callout.href}
      />
    );
  }

  renderFollows() {
    if (!this.props.followGroup) { return null; }

    return this.props.followGroup.follows.map((follow) => {
      return (
        <FollowRow
          actions={this.props.actions}
          enableDigestToggle={this.props.enableDigestToggle}
          follow={follow}
          key={follow.id}
        />
      );
    });
  }

  renderTitle() {
    if (!this.props.followGroup) { return null; }

    return this.props.followGroup.title;
  }

  shouldRenderSection() {
    if (!this.props.followGroup) { return true; }

    return !(this.props.followGroup.follows.length === 0
             && !this.props.followGroup.callout_link_text);
  }

  render() {
    if (!this.shouldRenderSection()) { return null; }

    return (
      <div className="feed-customize__section">
        <h2 className="feed-customize__subhead">
          {this.renderTitle()}
        </h2>

        <div className="feed-customize__tiles">
          <Tiles
            loading={!this.props.followGroup}
            placeholder={<FollowRow actions={this.props.actions} />}
          >
            {this.renderFollows()}
          </Tiles>
        </div>

        {this.renderCallout()}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./node_modules/@reverbdotcom/commons/src/components/follows_list.tsx